import type { FragmentType } from '@packages/gql/generated/shopping';
import type { ProductPowerSupplyFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductPowerSupplyFragmentFragmentDoc';
import { unmask } from '@packages/gql/src/betterMasking';
import { PowerSupply } from '@packages/shared/src/ui/PowerSupply';
import type { PowerSupplyProps } from '@packages/shared/src/ui/PowerSupply/PowerSupplyProps';

/* GraphQL */ `
  fragment ProductPowerSupplyFragment on PowerSupply {
    maxPower
    minPower
    chargerType
    powerSupplyIncluded
  }
`;

export type ProductPowerSupplyProps = {
  maskedData: FragmentType<typeof ProductPowerSupplyFragmentFragmentDoc>;
} & Pick<PowerSupplyProps, 'asCard' | 'showPowerSupplyMessage'>;

export const ProductPowerSupply = ({ maskedData, ...rest }: ProductPowerSupplyProps) => {
  const { maxPower, minPower, chargerType, powerSupplyIncluded } =
    unmask<typeof ProductPowerSupplyFragmentFragmentDoc>(maskedData);

  return (
    <PowerSupply
      maxPower={maxPower}
      minPower={minPower}
      chargerType={chargerType}
      powerSupplyIncluded={powerSupplyIncluded}
      {...rest}
    />
  );
};
